import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "../ui/button";
import { Menu, X } from "lucide-react";
import logoAtaric from "../../../../assets/logo-ataric.png";
import analytics from "../../../../libs/analytics";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (e: React.MouseEvent, sectionId: string) => {
    e.preventDefault();
    e.stopPropagation();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <motion.header
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6 }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-background/80 border-b border-border/50"
    >
      <div className="container mx-auto px-4 py-4 flex items-center justify-between">
        <a href="#" onClick={scrollToTop} className="flex items-center gap-2">
          <img src={logoAtaric} alt="Ataric" className="h-24 w-auto" style={{ marginRight: '60px' }} />
        </a>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          <button type="button" onClick={(e) => scrollToSection(e, 'beneficios')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            Benefícios
          </button>
          <button type="button" onClick={(e) => scrollToSection(e, 'oq-e-o-ataric')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            O que é o Ataric
          </button>
          <button type="button" onClick={(e) => scrollToSection(e, 'como-funciona')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            Como funciona o app
          </button>
          <button type="button" onClick={(e) => scrollToSection(e, 'depoimentos')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            Depoimentos
          </button>
          <button type="button" onClick={(e) => scrollToSection(e, 'planos')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            Planos
          </button>
          <button type="button" onClick={(e) => scrollToSection(e, 'faq')} className="text-muted-foreground hover:text-foreground transition-colors cursor-pointer">
            FAQ
          </button>
        </nav>

        <div className="hidden md:flex items-center gap-4">
          <a href="/blog" target="_blank" rel="noopener noreferrer" className="text-muted-foreground hover:text-foreground transition-colors">
            Blog
          </a>
          <a href="/login" className="text-muted-foreground hover:text-foreground transition-colors" onClick={() => analytics.landingLoginClicked('header')}>
            Acessar minha conta
          </a>
          <Button variant="cta" size="lg" asChild>
            <a href="/login" onClick={() => analytics.landingCtaClicked('header')}>Começar agora</a>
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-foreground"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="md:hidden bg-card border-b border-border"
        >
          <nav className="container mx-auto px-4 py-6 flex flex-col gap-4">
            <button type="button" onClick={(e) => scrollToSection(e, 'beneficios')} className="text-foreground py-2 text-left cursor-pointer">
              Benefícios
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'oq-e-o-ataric')} className="text-foreground py-2 text-left cursor-pointer">
              O que é o Ataric
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'como-funciona')} className="text-foreground py-2 text-left cursor-pointer">
              Como funciona o app
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'depoimentos')} className="text-foreground py-2 text-left cursor-pointer">
              Depoimentos
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'planos')} className="text-foreground py-2 text-left cursor-pointer">
              Planos
            </button>
            <button type="button" onClick={(e) => scrollToSection(e, 'faq')} className="text-foreground py-2 text-left cursor-pointer">
              FAQ
            </button>
            <div className="flex flex-col gap-3 pt-4 border-t border-border">
              <a href="/blog" target="_blank" rel="noopener noreferrer" className="text-foreground py-2">
                Blog
              </a>
              <a href="/login" className="text-muted-foreground" onClick={() => analytics.landingLoginClicked('header_mobile')}>
                Acessar minha conta
              </a>
              <Button variant="cta" size="lg" asChild>
                <a href="/login" onClick={() => analytics.landingCtaClicked('header_mobile')}>Começar agora</a>
              </Button>
            </div>
          </nav>
        </motion.div>
      )}
    </motion.header>
  );
};

export default Header;
